"use strict";
//@ts-nocheck
/*global $*/
/*global window*/
/*global document*/
/*global console*/
/*global setTimeout*/
/*global jRespond*/
/*global TYPO3*/
(function () {
    'use strict';
    // Create global objects
    window.gs1 = window.gs1 || {};
    TYPO3.lang = TYPO3.lang || {};
    TYPO3.settings = TYPO3.settings || {};
    var exports = {
        initializeErrorMessageHandling: function () {
            $('.vbg-order-form').find('.mandatory-message').find('a').on('click', function (event) {
                event.preventDefault();
                var $anchor = $(this);
                var $targetElement = $($anchor.attr('href'));
                var targetOffset = $targetElement.offset().top;
                $('html,body').animate({
                    scrollTop: targetOffset
                }, 500, function () {
                    $targetElement.trigger('focus');
                    $targetElement.trigger('select');
                });
            });
        },
        /**
         * GS1 Package Size Radio Element Manipulation
         */
        attachPackageSizeSelectionEvents: function () {
            $('#packageSize_S').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#packageSize').val($(this).val());
                    $('#packageSize_M, #packageSize_L').prop('checked', false);
                }
                else {
                    $('#packageSize').val('');
                }
            });
            $('#packageSize_M').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#packageSize').val($(this).val());
                    $('#packageSize_S, #packageSize_L').prop('checked', false);
                }
                else {
                    $('#packageSize').val('');
                }
            });
            $('#packageSize_L').on('change', function (event) {
                if ($(this).is(':checked')) {
                    $('#packageSize').val($(this).val());
                    $('#packageSize_S, #packageSize_M').prop('checked', false);
                }
                else {
                    $('#packageSize').val('');
                }
            });
        },
        /**
         * Disable the submit button in VBG order after submit (a.k.a. poor man's double click/double order prevention)
         */
        attachSubmitFormEvents: function () {
            $('form[name="order"]').submit(function () {
                $(this).find('button[type=submit]').prop('disabled', true);
            });
        }
    };
    exports.initializeErrorMessageHandling();
    exports.attachPackageSizeSelectionEvents();
    exports.attachSubmitFormEvents();
})();
